export const MAX_METRIC_KEY_LENGTH = 256;
import { msg } from '@gonfalon/messages/msg';
export const MAX_DATA_SOURCE_TABLE_LENGTH = 255;
export const MAX_METRIC_GROUP_KEY_LENGTH = 256;

// Data source previews send the query as a URL parameter, and requests whose path and query exceed
// 8192 bytes are rejected before they reach the warehouse. The remainder covers the path itself.
export const MAX_DATA_SOURCE_SQL_QUERY_URL_BYTES = 7500;

export const dataSourceSqlQueryTooLongMessage = () => msg('metrics.dataSourceForm.queryTooLong');

export const isDataSourceSqlQueryTooLong = (sqlQuery: string) =>
  encodeURIComponent(sqlQuery).length > MAX_DATA_SOURCE_SQL_QUERY_URL_BYTES;

// Functions so the copy resolves at render, after the messages provider mounts.
export const successCriteriaDisplayOptions = () =>
  [
    { value: 'HigherThanBaseline', displayName: msg('metrics.definitionSummary.higherIsBetter') },
    { value: 'LowerThanBaseline', displayName: msg('metrics.definitionSummary.lowerIsBetter') },
  ] as const;

export const UNIT_AGGREGATION_TYPE_DISPLAY_NAMES = {
  average: 'average',
  sum: 'sum',
} as const;

export const analysisTypeDisplayOptions = () => [
  { value: 'mean', displayName: msg('metrics.definitionSummary.average') },
  { value: 99, displayName: msg('metrics.definitionSummary.percentile', { value: 99 }) },
  { value: 95, displayName: msg('metrics.definitionSummary.percentile', { value: 95 }) },
  { value: 90, displayName: msg('metrics.definitionSummary.percentile', { value: 90 }) },
  { value: 75, displayName: msg('metrics.definitionSummary.percentile', { value: 75 }) },
  { value: 50, displayName: msg('metrics.definitionSummary.percentile', { value: 50 }) },
];

export const VALID_ANALYSIS_PERCENTILES = [99, 95, 90, 75, 50];

export const MAX_WINDOW_DAYS = 365;

/* An artificial type used by the FE to differentiate LD / external warehouses.
 * - LAUNCHDARKLY_HOSTED variant is an actual key, known to BE as the default LD data source.
 * - DATA_WAREHOUSE_HOSTED variant is not an actual data source key. Real external data source keys
 *   are retreivable from MetricDataSourceRep['key']
 *    */
export const enum DataSourceType {
  LAUNCHDARKLY_HOSTED = 'launchdarkly-hosted',
  DATA_WAREHOUSE_HOSTED = 'datawarehouse-hosted',
}

export const SNOWFLAKE_EXPERIMENTATION_INTEGRATION_KEY = 'snowflake-experimentation';
